import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {RootState} from "../../../../store";
import {FavMessageProps, switchFavMessage} from "./FavMessageSwitchAPI";

// Define a type for the slice state
interface CounterState {
    favMessageResp: {  },
    isFetching: boolean,
    status: string
}

// Define the initial state using that type
const initialState: CounterState = {
    favMessageResp: {},
    isFetching: false,
    status: "idle"
}


export const setFavMessage = createAsyncThunk(
    'switch/favMessage',
    async (fav :FavMessageProps) => {
        return  await switchFavMessage(fav)
    }
)

// Then, handle actions in your reducers:
// Then, handle actions in your reducers:
const switchFavMessageSlice = createSlice({
    name: 'switchFavMessage',
    initialState: initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
        clearGetChatAreaContent: (state) => {
            state.isFetching = false
            state.status = "IDLE"
            state.favMessageResp = {}
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder
            .addCase(setFavMessage.pending, (state) => {
                state.status = 'PENDING';
                state.isFetching = true;
            })
            .addCase(setFavMessage.fulfilled, (state, action) => {
                // Add user to the state array
                state.status = 'SUCCESS';
                state.isFetching = false;
                state.favMessageResp = action.payload;
            })
            .addCase(setFavMessage.rejected, (state) => {
                state.status = 'FAILED';
                state.isFetching = false;
            })
    },
})

export const setFavEmployeeSelector = (state: RootState) => state.setFavMessages;
export default switchFavMessageSlice.reducer
